import { gql } from '@apollo/client';

/**
 * Fragment for blocked email node
 */
export const BlockedEmailNodeFragment = gql`
  fragment BlockedEmailNodeFragment on BlockedEmail {
    id
    email
    reason
    createdAt
  }
`;

/**
 * Fragment for blocked email edge in connection
 */
export const BlockedEmailEdgeFragment = gql`
  fragment BlockedEmailEdgeFragment on BlockedEmailEdge {
    cursor
    node {
      ...BlockedEmailNodeFragment
    }
  }
  ${BlockedEmailNodeFragment}
`;

/**
 * Complete fragment for blocked email connection
 */
export const BlockedEmailConnectionFragment = gql`
  fragment BlockedEmailConnectionFragment on BlockedEmailConnection {
    edges {
      ...BlockedEmailEdgeFragment
    }
  }
  ${BlockedEmailEdgeFragment}
`;
